import { createAsyncThunk } from "@reduxjs/toolkit";
// import { APIClient } from "../../helpers/api_helper";
import axiosInstance from "../../helpers/axiosInstanceHelper";
import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_PROFILE } from "../../helpers/url_helper";
import { setCookieWithLocalStorage } from "../../helpers/browserStorageHelper";

const authLoginThunks = createAsyncThunk('auth/login', async (loginForm, {dispatch})=>{  
     const response= await axiosInstance.post(AUTH_LOGIN, loginForm);
     const { accessToken, refreshToken } = response.data;
     setCookieWithLocalStorage(accessToken, refreshToken);
     console.log(response)
     return response?.data;
});

const authLogoutThunks = createAsyncThunk('auth/logout', async ()=>{
     const response= await axiosInstance.post(AUTH_LOGOUT);
     return response?.data;
});

const authProfileThunks = createAsyncThunk('auth/profile', async ()=>{
     const response= await axiosInstance.get(AUTH_PROFILE);
     return response?.data;
});



export {authLoginThunks, authLogoutThunks, authProfileThunks}
